var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253,124c-.44-.72-10.94-17.6-31.57-34.66-27.33-22.61-59.53-34.56-93.1-34.56S62.42,66.72,34.93,89.31C14.4,106.18,3.57,123.23,3.12,124L.59,128l2.52,4.05c1.14,1.8,11.67,18.08,31.82,34.65,27.49,22.59,59.77,34.53,93.34,34.53s65.75-11.95,93.1-34.56c20.58-17,31.13-33.94,31.57-34.66l2.47-4ZM128.28,185.85c-30.18,0-58.11-10.31-83-30.65a154.87,154.87,0,0,1-25.91-26.9l-.23-.3.23-.3a155.61,155.61,0,0,1,25.91-26.9c24.93-20.34,52.86-30.65,83-30.65s58,10.3,82.75,30.63a153.13,153.13,0,0,1,25.71,26.92l.22.3-.22.3A153.42,153.42,0,0,1,211,155.22C186.27,175.54,158.43,185.85,128.28,185.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,79.6A48.41,48.41,0,1,0,176.76,128,48.63,48.63,0,0,0,128,79.6Zm0,82a33.75,33.75,0,0,1-31.27-20.76,33.38,33.38,0,0,1,7.34-36.66A33.74,33.74,0,1,1,128,161.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisible);
export default __webpack_public_path__ + "static/media/icon-visible.806d63b8.svg";
export { ForwardRef as ReactComponent };